import { Report1913 } from "../../../components/borrowSystem/Report/Report1913";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1913Container() {
  const titleName =
    " การจัดสรรเป้าหมายการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1913 />
      <Footer />
    </div>
  );
}
